import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//
import CouFigure from "./CouFigure";
//
const CouImageThumbnailStyled = styled.div`
  position: relative;
`;

const CouImageThumbnailDelete = CouImageThumbnailStyled.extend`
  font-size: 0.8rem;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
`;

const Button = styled.button`
  background: #000;
  border: 0;
  border-radius: 0;
  color: #fff;
  cursor: pointer;
  outline: none;

  &:focus {
    outline: none;
  }
`;

class CouImageThumbnail extends Component {
  state = {
    deleting: false,
  };

  onDelete = (event) => {
    event.preventDefault();
    this.props.onDelete(this.props.inputIndex);
  };

  onCaptionChange = (event) => {
    this.props.onCaptionChange(this.props.inputIndex, event.target.value);
  };

  toggleDeleteConfirm = (event) => {
    event.preventDefault();
    this.setState({ deleting: !this.state.deleting });
  };

  render() {
    const { allowDelete, file } = this.props;
    const { caption, url } = file;
    const { deleting } = this.state;

    let button = "";
    if (allowDelete) {
      button = (
        <CouImageThumbnailDelete>
          <Button onClick={this.toggleDeleteConfirm}>X</Button>
        </CouImageThumbnailDelete>
      );

      if (deleting) {
        button = (
          <CouImageThumbnailDelete>
            <Button onClick={this.toggleDeleteConfirm}>Cancel</Button>
            <Button onClick={this.onDelete}>Delete</Button>
          </CouImageThumbnailDelete>
        );
      }
    }

    return (
      <CouImageThumbnailStyled>
        {button}
        <CouFigure
          url={url}
          caption={caption}
          width={800}
          allowCaption={false}
        />
        {/* <div className="form-group string optional">
          <input
            className="form-control string optional CouImageThumbnail-caption"
            value={caption}
            onChange={this.onCaptionChange}
            placeholder="Caption"
          />
        </div> */}
      </CouImageThumbnailStyled>
    );
  }
}

CouImageThumbnail.defaultProps = {
  allowDelete: true,
};

CouImageThumbnail.propTypes = {
  allowDelete: PropTypes.bool,
  file: PropTypes.shape({
    caption: PropTypes.string,
    url: PropTypes.string.isRequired,
  }).isRequired,
  inputIndex: PropTypes.number.isRequired,
  onCaptionChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CouImageThumbnail;
